import { render, staticRenderFns } from "./companyNews.vue?vue&type=template&id=dd9de786&scoped=true"
import script from "./companyNews.vue?vue&type=script&lang=js"
export * from "./companyNews.vue?vue&type=script&lang=js"
import style0 from "./companyNews.vue?vue&type=style&index=0&id=dd9de786&prod&scoped=true&lang=less"
import style1 from "./companyNews.vue?vue&type=style&index=1&id=dd9de786&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9de786",
  null
  
)

export default component.exports